import { ref } from '@vue/composition-api'
import {
  mdiCloseOutline,
  mdiCheckOutline,
} from '@mdi/js'

export default function useIsPaymentList() {
  const isPaymentList = ref([
    {
      id: 1,
      text: 'Pago',
      color: '#66BB6A',
      icon: mdiCheckOutline,
    }, {
      id: 0,
      text: 'Reem',
      color: '#EF5350',
      icon: mdiCloseOutline,
    },
  ])

  const GetById = id => isPaymentList.value.find(item => item.id === id)

  return {
    isPaymentList,
    GetById,
  }
}
